module.exports = __webpack_public_path__ + "img/evil.8723a4ee.png";